import React, { useMemo } from 'react';
import DT from 'duration-time-conversion';
import { searchValueInText } from '../../utils';
import useCurrentItemIndex from '../../utils/useCurrentItemIndex';
import TranscriptItem from '../TranscriptItem';
import PlaceholderEmpty from '../PlaceholderEmpty';
import OPTIONS from '../ViewsSelector/options';

const option = OPTIONS.find((o) => o.value === 'ocr') || {};
const ENTITY = option.text || 'OCR';
const ICON = option.icon;

const Ocr = ({
  ocr = [], searchValue, currentTime, setVideoPlayerCurrentTime, revisionId, assetId,
}) => {
  const items = useMemo(() => {
    let result = ocr;
    if (searchValue) {
      result = result.filter(({ text }) => text.toLowerCase().includes(searchValue.toLowerCase()));
    }
    return result
      .reduce((acc, curr) => {
        const { text } = curr;
        curr.segments.forEach((segment) => {
          acc.push({ ...segment, text });
        });
        return acc;
      }, [])
      .sort((a, b) => DT.t2d(a.startTime) - DT.t2d(b.startTime));
  }, [ocr, searchValue]);

  const [activeItemIndex, setTime] = useCurrentItemIndex(items, currentTime, setVideoPlayerCurrentTime);

  if (!items.length) return <PlaceholderEmpty entity={ENTITY} icon={ICON} isSearch={!!searchValue} />;

  return items.map(({
    startTime, endTime, text,
  }, i) => (
    <TranscriptItem
      key={startTime + endTime + text}
      isActive={activeItemIndex === i}
      setVideoPlayerCurrentTime={setTime}
      activeRevisionID={revisionId}
      startTime={startTime}
      endTime={endTime}
      text={searchValueInText(text, searchValue)}
      assetId={assetId}
      clickEvent="VideoIntelligenceOCREntityClicked"
    />
  ));
};

export default Ocr;
